<template>
  <div class="my-table userPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('editDesktopDot.txt1')}}</span>
        <span>{{$t('editDesktopDot.txt2')}} / {{$t('editDesktopDot.txt3')}} /{{dotParams.id?$t('editDesktopDot.txt4'):$t('editDesktopDot.txt5')}}</span>
      </div>
      <div class="flexEnd">
        <div class="searchBtn ml20" @click="onBack">{{$t('editDesktopDot.txt6')}}</div>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{dotParams.id?$t('editDesktopDot.txt4'):$t('editDesktopDot.txt5')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="onBack">{{$t('editDesktopDot.txt7')}}</div>
          <div class="searchBtn" @click="confirmAddDot('dotParams')">{{$t('editDesktopDot.txt8')}}</div>
        </div>
      </div>
      <div class="editForm editWidth">
        <el-form :model="dotParams" :rules="addDotRules" ref="dotParams" class="demo-ruleForm">
          <el-form-item :label="$t('editDesktopDot.txt9')" prop="desktopName">
            <el-input :placeholder="$t('editDesktopDot.txt10')" v-model="dotParams.desktopName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('editDesktopDot.txt11')" prop="lanIp">
            <el-input :placeholder="$t('editDesktopDot.txt12')" v-model="dotParams.lanIp"></el-input>
          </el-form-item>
          <el-form-item :label="$t('editDesktopDot.txt13')" prop="wanIp">
            <el-input :placeholder="$t('editDesktopDot.txt14')" @change="getNewDesktopUrl" v-model="dotParams.wanIp"></el-input>
          </el-form-item>
          <el-form-item :label="$t('editDesktopDot.txt15')" prop="desktopPort">
            <el-input :placeholder="$t('editDesktopDot.txt16')" @change="getNewDesktopUrl" v-model="dotParams.desktopPort"></el-input>
          </el-form-item>
          <el-form-item :label="$t('editDesktopDot.txt17')" prop="desktopUrl">
            <el-input :disabled="true" :placeholder="$t('editDesktopDot.txt18')" v-model="desktopUrl"></el-input>
          </el-form-item>
          <el-form-item :label="$t('editDesktopDot.txt19')" prop="desktopDescribe">
            <el-input type="textarea" v-model="dotParams.desktopDescribe" :placeholder="$t('editDesktopDot.txt20')" maxlength="100" show-word-limit></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    
  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        dotParams:{
          id:"",
          desktopName:"",
          lanIp:"",
          wanIp:"",
          desktopPort:"300",
          desktopUrl:"",
          desktopDescribe:"",
          userInfos:[],
          online:true,
          state: 1
        },//添加节点参数
        desktopUrl:'',
        // 添加节点规则
        addDotRules: {
          desktopName: [
          { required: true, message: this.$t('editDesktopDot.txt21'), trigger: 'blur' },
          { pattern: /^[a-zA-Z]{1}\w*$/, message: this.$t('editDesktopDot.txt22') }
          ],
          lanIp:[
          { required: true, message: this.$t('editDesktopDot.txt23'), trigger: 'blur' },
          { pattern: /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/, message: this.$t('editDesktopDot.txt24') },
          ],
          wanIp:[
          { required: true, message: this.$t('editDesktopDot.txt25'), trigger: 'blur' },
          { pattern: /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/, message: this.$t('editDesktopDot.txt26') },
          ],
          desktopPort:[
          { required: true, message: this.$t('editDesktopDot.txt27'), trigger: 'blur' },
          { pattern: /^([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/, message: this.$t('editDesktopDot.txt28') },
          ],
        },
      };
    },
    created() {
      this.dotParams.id = this.$route.query.id?this.$route.query.id:'';
      this.getNewDesktopUrl();
      if(this.dotParams.id){
        this.getDesktopInfo();
      }
    },

    methods: {
      onBack(){
        this.$router.go(-1);
      },
      getNewDesktopUrl(){
        let wanIp = this.dotParams.wanIp?this.dotParams.wanIp:'--';
        let desktopPort = this.dotParams.desktopPort?this.dotParams.desktopPort:'300';
        this.desktopUrl = 'https://'+wanIp+':'+desktopPort +'/main/home'
      },
      // 桌面节点详细
      async getDesktopInfo() {
        let data = {
          desktopId: this.dotParams.id
        }
        const {
          data: res
        } = await this.$http.post("/desktop/getDesktopInfo?"+qs.stringify(data));
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.dotParams = res.result;
      },
      // 添加编辑节点操作
      confirmAddDot(formName) {
       this.$refs[formName].validate((valid) => {
         if (valid) {
           this.add(this.dotParams);
         } else {
           console.log('error submit!!');
           return false;
         }
       });
     },
      // 节点管理添加/修改
      async add(params){
        let userInfos = [];
        params.userInfos.map(e=>{
          userInfos.push(e);
        })
        let data = params;
        data.userInfos = userInfos;
        let wanIp = params.wanIp?params.wanIp:'--';
        let desktopUrl = params.desktopPort?params.desktopPort:'300';
        data.desktopUrl = 'https://'+wanIp+':'+desktopUrl+'/main/home';
        const { data: res } = await this.$http.post("/desktop/add",data);
        if(res.success){
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.$router.go(-1);
        }else{
          return this.$message.error(res.message);
        }
      },
    },
  };
</script>

<style lang="less" scoped>

  .handleBtn{
    padding: 0;
  }
  .userPage{
    /deep/ .el-upload__input{
      display: none !important;
    }
    /deep/ .el-date-editor .el-range-separator{
      margin-top: -5px;
      width: 8%;
    }
    .contactTitle{
      margin-bottom: 40px;
    }
    .contactTitle span{
      margin-right: 30px;
      cursor: pointer;
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .w350{
      width: 350px;
    }
    .searchUserBox{
      /*width: 33.6rem !important;*/
      height: 3.2rem;
      margin-bottom: 3rem;
      /deep/ .el-input__inner{
        border:1px solid #C0C0C0;
        border-right:none;
      }
      /deep/ .el-input-group__append{
        border:1px solid #C0C0C0;
        border-left:none;
        padding:0;
        background: #fff;
      }
      /deep/ .el-input-group__append button.el-button{
        padding:0;
        width: auto;
        margin-right: 1.1rem;
      }
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    .editForm{}
    /deep/  .el-date-table td.today span{
      color: #fff;
      background: #1B3B7C;
      border-radius: 100%;
    }
    /deep/ .el-date-table td.end-date span,/deep/ .el-date-table td.start-date span{
      background: #1B3B7C !important;
    }

  }

</style>
